/**
 * Logs message into console if proper UTM set to truthy value.
 * @param {Object} - Configuration with log details.
 * @param {String} message - Message to be logged (warned or errored).
 * @param {('log'|'warn'|'error')} type - Type of console, if not specified defaults to "log".
 * @param {String} subName - additional service name subtype, can be used to log error code number
 * @param {Object} obj - Data to be displayed as in console.
 */
const log = (config, message, type = 'log', subName, obj) => {
    const { name, fColor, bColor } = config;
    const style = `display: inline-block; color: ${fColor}; background: ${bColor}; padding: 1px 4px; border-radius: 3px;`;
    const displayName = `%c${name}${subName ? ' ' + subName : ''}`;
    console[type](displayName, style, message);
    if (obj && (Object.keys(obj).length > 0 || obj instanceof Error)) {
        console[type](displayName, style, obj);
    }
};
export { log };
